import { create, w, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { Dialog } from '@dojo/widgets/dialog';
import Button from '@dojo/widgets/button';
import { createNlsMiddleware, assessmentChange, userstate } from 'lcc-state';
import { svc } from '../support/svc';
import css from '../css/studyplan.m.css';
const nls = createNlsMiddleware('settings');
const ditabookNls = createNlsMiddleware('ditabook');
const factory = create({
    icache: createICacheMiddleware(),
    theme,
    nls,
    ditabookNls,
    userstate
}).properties();
export const StudyPlanConfirmation = factory(({ properties, middleware: { icache, theme, nls, ditabookNls, userstate } }) => {
    const themeCss = theme.classes(css);
    const { callback } = properties();
    const { get, path } = userstate;
    const quizPattern = get(path('quizPattern')) || '';
    const scores = get(path('assessment')) || {};
    const { messages: { ml_study_plan_title = '[settings] ml_study_plan_title', ml_study_plan_text = '[settings] ml_study_plan_text', ml_study_plan_continue_button = '[settings] ml_study_plan_continue_button' } } = nls();
    const { messages: { recommended_to_flag = '3' } } = ditabookNls();
    const tgf_recommendations = parseInt(recommended_to_flag);
    const recommended_plan = icache.getOrSet('recommendations', async () => {
        const recommendations = await svc.recommended_study_plan({
            studyTrack: quizPattern,
            scores,
            tgf_recommendations
        });
        return recommendations;
    });
    const update_state = () => {
        if (recommended_plan) {
            assessmentChange({ assessment: recommended_plan });
            callback();
        }
    };
    const content = v('div', { classes: [themeCss.root] }, [
        v('div', { classes: [themeCss.title] }, [ml_study_plan_title]),
        v('div', { classes: [themeCss.content] }, [
            v('div', { classes: [themeCss.body], innerHTML: ml_study_plan_text }),
            w(Button, {
                disabled: !recommended_plan,
                onClick: update_state
            }, [{ label: ml_study_plan_continue_button }])
        ])
    ]);
    return w(Dialog, {
        open: true,
        underlay: true,
        closeable: true,
        onRequestClose: callback
    }, [{ content }]);
});
